import { configureStore } from '@reduxjs/toolkit';
import { AuthSlice } from './Slice/AuthSlice';
import { ProdCatUnitSlice } from './Slice/ProdCatUnitSlice';
import { VendorSlice } from './Slice/VendorSlice';
import { ChalanSlice } from './Slice/ChalanSlice';
import { StockedItemSlice } from './Slice/StockedItemSlice';
import { CustomerSlice } from './Slice/CustomerSlice';
import { InvoiceSlice } from './Slice/InvoiceSlice';
import { StaffSlice } from './Slice/StaffSlice';
import { UserSlice } from './Slice/UserSlice';
import { LoanSlice } from './Slice/LoanSlice';
import { DashboardSlice } from './Slice/DashboardSlice';
import { WarrantySlice } from './Slice/WarrantySlice';
import BankAccountSlice from './Slice/BankAccountSlice';
import StoreSlice from './Slice/StoreSlice';
import { AlertSlice } from './Slice/AlertSlice';

export const Store = configureStore({
  reducer: {
    authSlice: AuthSlice.reducer,
    prodCatUnitSlice: ProdCatUnitSlice.reducer,
    vendorSlice: VendorSlice.reducer,
    chalanSlice: ChalanSlice.reducer,
    stockedItemSlice: StockedItemSlice.reducer,
    customerSlice: CustomerSlice.reducer,
    invoiceSlice: InvoiceSlice.reducer,
    staffSlice: StaffSlice.reducer,
    userSlice: UserSlice.reducer,
    loanSlice: LoanSlice.reducer,
    dashboardSlice: DashboardSlice.reducer,
    warrantySlice: WarrantySlice.reducer,
    bankAccountSlice: BankAccountSlice.reducer,
    storeSlice: StoreSlice.reducer,
    alertSlice: AlertSlice.reducer
  },
});
